import { render, staticRenderFns } from "./PortfoliosToInvestCardLoader.vue?vue&type=template&id=78e28f82&scoped=true&"
import script from "./PortfoliosToInvestCardLoader.vue?vue&type=script&lang=ts&"
export * from "./PortfoliosToInvestCardLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PortfoliosToInvestCardLoader.vue?vue&type=style&index=0&id=78e28f82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e28f82",
  null
  
)

export default component.exports